import { fetch } from '@/plugins/polyfill/fetch'
import { calcSaltSign, calcSaltSignType3 } from './calc_salt_sign'
import { getRequestCommonParams, getRequestHeaderInfo } from './common_params'
import { Errors } from '@/defines/errors'
import { eventbus } from '@/utils/eventbus'
import { EventNames } from '@/defines/events'
import {
  isEncryptedResponse,
  decryptFnType1,
  decryptFnType2,
  decryptFnType3
} from './decrypt'
import { userInfo } from '@/utils/user'
import { stimeConfig } from '@/utils/stime'
import { DialogAlert } from '@/utils/dialog.js'
export const request = async (url, data) => {
  try {
    const options = {
      method: 'POST',
      mode: 'cors',
      credentials: 'include'
    }
    if (!(data instanceof FormData)) {
      const mcGray = userInfo?.getMcGray() || ''
      Object.assign(options, {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Device-Token': getRequestHeaderInfo().deviceToken || '',
          'Company-Token': getRequestHeaderInfo().companyToken || '',
          'Passport-Token': getRequestCommonParams().tickets,
          'Mc-Gray': mcGray
        }
      })
    }
    if (!data) data = {}
    if (data instanceof FormData) {
      data.append('tickets', getRequestCommonParams().tickets)
      Object.assign(options, {
        body: data
      })
    } else {
      Object.assign(data, getRequestCommonParams())

      data.mallSaltSign = calcSaltSignType3(data) || ''
      data.salt_sign = calcSaltSign(data)
      Object.assign(options, {
        body: JSON.stringify(data)
      })
    }
    const response = await fetch(url, options)
    if (response.ok) {
      const body = await response.json()
      const { ret, error, encryption } = body
      if (ret === 0 && (error?.code === 1012002 || error?.code === 2003)) {
        eventbus.dispatch(EventNames.loginChange, false)
        // login()
        return Promise.reject({
          type: Errors.AUTH.NOT_LOGIN,
          res: body
        })
      } else if (ret === 0 && error?.code === 1013014) {
        eventbus.dispatch(EventNames.loginChange, false)
        window.alert(error.msg || '该账号无效，若有疑问请联系客服4006-135-135')
        // login()
        return Promise.reject({
          type: Errors.AUTH.NOT_LOGIN,
          res: body
        })
      } else if (ret === 0 && error?.code === 2026001) {
        // 处理时间偏移量错误，从header获取stime
        // 打印所有响应头以调试
        // 获取stime头
        const stime = response.headers.get('stime')
        if (stime) {
          stimeConfig.setOffsetTime(stime)
        }
        const msg = error?.msg
        return DialogAlert(msg)
        // return Promise.reject(error)
      } else if (ret === 0) {
        eventbus.dispatch(EventNames.loginChange, true)
        return Promise.reject({
          type: Errors.AJAX.RESPONSE_ERROR,
          res: body
        })
      } else {
        eventbus.dispatch(EventNames.loginChange, true)
        let decryptData = {}
        if (isEncryptedResponse(encryption)) {
          if (encryption.type === 1) {
            decryptData = decryptFnType1(body.data, encryption)
          } else if (encryption.type === 2) {
            decryptData = decryptFnType2(body.data, encryption)
          } else if (encryption.type === 3) {
            decryptData = decryptFnType3(body.data, encryption)
          }
        }
        return Promise.resolve(Object.assign(body, decryptData))
      }
    } else {
      return Promise.reject({
        type: Errors.AJAX.NETWORK_ERROR,
        response
      })
    }
  } catch (error) {
    return Promise.reject(error)
  }
}
